<template>
  <div id="layout-default">
    <header class="sticky-top">
      <slot name="header"></slot>
    </header>
    <main>
      <transition name="fade" mode="out-in" appear>
        <slot name="pages"></slot>
      </transition>
      <div
        id="scrollTop"
        class="d-flex align-items-center"
        data-aos="fade-zoom-in"
        data-aos-easing="ease-out-back"
        data-aos-anchor-placement="center-bottom"
      >
        <div
          class="scrollTop d-flex align-items-center justify-content-center"
          @click.prevent="scrollTop"
        >
          <Icons name="up" color="#fff" :width="30" :height="30" />
        </div>
      </div>
      <div
        v-if="this.$route.name==='Special-Offer' && (scrollY+300)<wrapH"
        class="scroll-coupon d-flex align-items-center justify-content-center"
        @click.prevent="scrollTop"
      >
        <Icons name="up" color="#fff" :width="30" :height="30" />
      </div>
    </main>
    <footer>
      <slot name="footer"></slot>
    </footer>
  </div>
</template>

<style lang="scss">
#layout-default {
  main {
    position: relative;
    min-height: calc(100vh - 74px - 429px);
    #scrollTop {
      position: absolute;
      left: 0;
      right: 0;
      bottom: -30px;
      justify-content: center;
      @media (min-width: 768px) {
        justify-content: flex-end;
        padding-right: 80px;
      }
      .scrollTop {
        cursor: pointer;
        width: 60px;
        height: 60px;
        background-color: $primary;
      }
    }
    .scroll-coupon {
      position: fixed;
      right: 20px;
      bottom: 50px;
      cursor: pointer;
      width: 60px;
      height: 60px;
      background-color: $primary;
      @media (min-width: 768px) {
        right: 50px;
      }
    }
  }
  .fade-enter-active,
  .fade-leave-active {
    transition: opacity 0.5s;
  }
  .fade-enter,
  .fade-leave-to {
    opacity: 0;
  }
}
</style>
<script>
import Icons from '@/components/icon.vue';
import { mapGetters } from 'vuex';

export default {
  name: 'Layout',
  components: {
    Icons,
  },
  computed: {
    ...mapGetters(['screenWidth', 'scrollY', 'wrapH']),
  },
  methods: {
    scrollTop() {
      window.scrollTo(0, 0);
    },
  },
};
</script>
